import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    FileField,
    FileInput,

    SaveButton,
    Toolbar,

    TabbedShowLayout,
    Tab,
    ImageField,
    WrapperField,
    RichTextField,
    FunctionField,
    useRecordContext,
    UrlField,
    ArrayInput,
    SimpleFormIterator,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
    ShowButton,
    InfiniteList,
    useRedirect,
} from 'react-admin';
import Alert from "@mui/material/Alert";
import { capitalizeFirst, formEntryStatuses, formStatuses, getFriendlySettingName, getSettingDescription, hasJsonStructure, locationString } from "../helpers/strings";
import { FormEntryField } from "./FormEntries";
import { format, parseISO } from "date-fns";

const ReportList = props => {
    const redirect = useRedirect();
    React.useEffect(() => {
        redirect('/form-entries/average');
    }, []);

    return null;
}

/*
const ReportList = props => (
    <List title={"All Settings"} {...props}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} />
        </Datagrid>
    </List>
);
*/

const ReportShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} />
            <FunctionField label="Description" render={record => getSettingDescription(record.name)} />
            {/* <SettingViewer source="value" /> */}
        </SimpleShowLayout>
    </Show>
);

const AuditLogSubjectField = (props) => {
    const record = useRecordContext(props);

    if(!record) {
        return null;
    }

    if(record.subject_type === 'App\Models\FormEntry') {
        return (
            <ReferenceField reference="form-entries" source="subject_id" {...props}>
                <TextField source="subject.community.name"/>
            </ReferenceField>
        );
    }

    return null;
}

const AuditLogList = props => (
    <InfiniteList title={"Audit Log"} resource="audit-log">
        <Datagrid rowClick={false} bulkActionButtons={false}>
            {/* <TextField source="id" /> */}
            <DateField source="created_at" label="Timestamp" showTime />

            {/* <FunctionField label="Action Type" render={record => capitalizeFirst(record.description)}/> */}

            <FunctionField label="Status" render={record => {
                const oldStatus = record.properties?.old?.status;
                const newStatus = record.properties.attributes.status;
                return <>{formEntryStatuses[oldStatus] ?? 'N/A'} <em>changed to</em> {formEntryStatuses[newStatus] ?? 'N/A'}</>;
            }}/>

            {/* <AuditLogSubjectField label="Record"/> */}

            <ReferenceField reference="form-entries" source="subject_id" label="Record" link="show">
                <TextField source="community.name"/>
                <br/>
                <FunctionField render={record => locationString(record.community)} />
            </ReferenceField>

            {/*
            <ReferenceField reference="form-entries" source="subject_id" label="Record">
                <TextField source="name"/>
            </ReferenceField>
            */}

            <ReferenceField reference="users" source="causer.id" label="User" link="show">
                <TextField source="name"/>
            </ReferenceField>

            <ShowButton/>

        </Datagrid>
    </InfiniteList>
);

const AuditLogShowAlert = (props) => {
    const record = useRecordContext(props);
    if(!record) {
        return null;
    }

    return (
        <Alert severity="info" sx={{alignItems: 'center'}}>
            This is entry data's snapshot from <b>{format(parseISO(record.created_at), 'MM/dd/yy \'at\' hh:mm aaaa')}</b>
            <br/>
            The entry's status at this time was <b>{formEntryStatuses[record.subject.status] ?? 'N/A'}</b> and was set by <b>{record.causer.name}</b>
        </Alert>
    );
}

const AuditLogFormEntryField = (props) => {
    const record = useRecordContext(props);
    console.log(record);

    return record ? (<FormEntryField data={[record.subject]}/>) : null;
}

const AuditLogShow = (props) => {
    const record = useRecordContext(props);


    console.log(props);
    /*
    if(!record) {
        return null;
    }
    */

    return (
        <Show {...props}>
            <AuditLogShowAlert/>
            <SimpleShowLayout>
                <AuditLogFormEntryField/>
            {/* {record && (<> */}

                {/* <FormEntryField data={[record.properties.attributes]} /> */}
                {/* <FormEntryField data={[record.subject]} /> */}
                {/* </>)} */}
                {/* <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} /> */}
                {/* <FunctionField label="Description" render={record => getSettingDescription(record.name)} /> */}
                {/* <SettingViewer source="value" /> */}
            </SimpleShowLayout>
        </Show>
    );
};

export {ReportList, ReportShow, AuditLogList, AuditLogShow};
